import React, { useState } from "react";
import { Link } from "react-router-dom";
import GeoDistrict from "./geoDistrict";
import GeoState from "./geoState";
import GeoCity from "./geoCity";
import GeoCenter from "./geoCenter";
import GeoHPC from "./geohpc";

const GeoTabs = () => {

    const [activeTab, setActiveTab] = useState("Geography");

    const tabData = [
        {
            icon: <i className="fas fa-globe" />,
            name: "Geography",
            content: <GeoState />
        },
        {
            icon: <i className="fas fa-map-location-dot" />,
            name: "District",
            content: <GeoDistrict />
        },
        {
            icon: <i className="fas fa-city" />,
            name: "City",
            content: <GeoCity />
        },
        {
            icon: <i className="fas fa-map-pin" />,
            name: "Center",
            content: <GeoCenter />
        },
        {
            icon: <i className="fas fa-chart-line" />,
            name: "HPC",
            content: <GeoHPC />
        },
    ]
    return (
        <>
            <div className="content container" style={{ maxWidth: "1500px" }}>
                <div className="row">
                    <div className="sortby-section">
                        <div className="sorting-info">
                            <div className="row d-flex align-items-center">
                                <div className="col-xl-12 col-lg-12 col-sm-12 col-md-12">
                                    <div className="coach-court-list">
                                        <ul className="nav">
                                            {tabData.map((tab, i) => (
                                                <li key={i}>
                                                    <Link
                                                        to="#"
                                                        className={tab.name === activeTab ? "active" : ""}
                                                        onClick={() => setActiveTab(tab.name)}
                                                    >
                                                        {tab.icon} {tab.name}
                                                    </Link>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                                <div className="tab-content">
                                    {tabData
                                        .filter(tab => tab.name === activeTab)
                                        .map((tab, i) => (
                                            <div key={i}>{tab.content}</div>
                                        ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default GeoTabs;